
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M19 3a1 1 0 011 1v5a1 1 0 01-1 1h-5a1 1 0 110-2h2.474A6 6 0 1015 17.196a1 1 0 111 1.732 8 8 0 112-12.222V4a1 1 0 011-1z"}})])
          )
        }
      }
    